/* eslint-disable import/first */
import React from 'react';
import css from './index.module.scss';

export default function ProductName({ productName }) {
  return <div className={css.title}>{productName}</div>;
}
